import { categories } from '@/mocks/categories';

const featuredCategories = [
  { ...categories[0], hasImage: true, imageSeq: 'grid-shoes-v2' },
  { ...categories[1], hasImage: true, imageSeq: 'grid-hoodies-v2' },
  { ...categories[2], hasImage: true, imageSeq: 'grid-tshirts-v2' },
  { ...categories[3], hasImage: true, imageSeq: 'grid-jackets-v2' },
  { ...categories[4], hasImage: true, imageSeq: 'grid-pants-v2' },
  { ...categories[5], hasImage: true, imageSeq: 'grid-headwear-v2' },
];

const cardImages = [
  'https://readdy.ai/api/search-image?query=Artistic%20top-down%20flatlay%20of%20premium%20sneakers%20collection%20in%20warm%20terracotta%20and%20cream%20tones%2C%20arranged%20in%20elegant%20grid%20pattern%2C%20soft%20directional%20lighting%2C%20high-end%20editorial%20product%20photography%2C%20clean%20minimal%20composition%20with%20intentional%20negative%20space%2C%20sophisticated%20fashion%20catalog%20aesthetic&width=800&height=600&seq=grid-shoes-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20draped%20elegantly%20on%20light%20sand%20colored%20surface%2C%20soft%20cashmere%20texture%20visible%2C%20warm%20golden%20hour%20lighting%2C%20minimal%20lifestyle%20fashion%20photography%2C%20relaxed%20sophisticated%20composition%2C%20neutral%20earth%20tone%20palette%2C%20premium%20apparel%20aesthetic&width=800&height=600&seq=grid-hoodies-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20oatmeal%20linen%20background%2C%20soft%20natural%20window%20light%2C%20clean%20minimal%20product%20photography%2C%20subtle%20fabric%20texture%20detail%2C%20refined%20casual%20fashion%20aesthetic%2C%20gentle%20shadow%20play&width=300&height=300&seq=grid-tshirts-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Stylish%20tailored%20jacket%20hanging%20on%20wooden%20hanger%20against%20warm%20beige%20wall%2C%20soft%20diffused%20studio%20lighting%2C%20sophisticated%20editorial%20fashion%20photography%2C%20elegant%20minimal%20composition%2C%20premium%20fabric%20texture%2C%20high-end%20boutique%20visual%20style&width=800&height=600&seq=grid-jackets-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Well-tailored%20trousers%20and%20casual%20shorts%20arranged%20artistically%20on%20light%20sand%20background%2C%20soft%20morning%20light%2C%20clean%20minimal%20fashion%20flatlay%2C%20refined%20texture%20detail%2C%20contemporary%20wardrobe%20essential%20aesthetic%2C%20harmonious%20neutral%20composition&width=800&height=600&seq=grid-pants-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20collection%20of%20minimal%20caps%20and%20berets%20arranged%20on%20warm%20ivory%20surface%2C%20soft%20diffuse%20natural%20lighting%2C%20sophisticated%20accessories%20photography%2C%20clean%20creative%20composition%2C%20refined%20style%20statement%2C%20gentle%20warm%20tones%20with%20subtle%20shadows&width=800&height=600&seq=grid-headwear-v2&orientation=landscape',
];

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14">
          <div className="flex items-end gap-6">
            <div className="flex flex-col">
              <span className="font-heading text-5xl md:text-6xl font-bold text-foreground-400 leading-none tracking-tight">
                ITAO
              </span>
              <span className="font-heading text-5xl md:text-6xl font-bold text-foreground-400 leading-none tracking-tight">
                BUY
              </span>
            </div>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4 md:mt-0">
            Le Nostre Categorie
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <a
            href={featuredCategories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src={cardImages[0]}
              alt="Scarpe"
              title="Shoes - Itaobuy Spreadsheet"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute top-4 left-4">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                Top Category
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <h3 className="text-3xl md:text-4xl font-bold text-background-50">
                {featuredCategories[0].name}
              </h3>
              <p className="text-foreground-300 text-sm mt-1">Scopri la collezione completa</p>
            </div>
          </a>

          <a
            href={featuredCategories[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src={cardImages[1]}
              alt="Felpe"
              title="Hoodies/Sweaters - Itaobuy Spreadsheet"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute top-4 left-4">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                Hoodies
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <h3 className="text-2xl md:text-3xl font-bold text-background-50">
                Hoodies/Sweaters
              </h3>
            </div>
          </a>

          <a
            href={featuredCategories[2].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src={cardImages[2]}
              alt="T-Shirts"
              title="T-Shirts - Itaobuy Spreadsheet"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
            <div className="absolute top-4 right-4">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                {featuredCategories[2].name}
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <p className="text-background-50 text-sm max-w-[180px]">
                Magliette di tendenza per ogni stile
              </p>
            </div>
          </a>

          <a
            href={featuredCategories[3].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src={cardImages[3]}
              alt="Giubbotti"
              title="Jackets - Itaobuy Spreadsheet"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6">
              <h3 className="text-2xl md:text-3xl font-bold text-background-50">
                Jackets
              </h3>
            </div>
          </a>

          <a
            href={featuredCategories[4].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src={cardImages[4]}
              alt="Pantaloni"
              title="Pants/Shorts - Itaobuy Spreadsheet"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6">
              <h3 className="text-2xl md:text-3xl font-bold text-background-50">
                Pants/<br />Shorts
              </h3>
              <p className="text-foreground-300 text-sm mt-1">Pantaloni e shorts per ogni occasione</p>
            </div>
          </a>

          <a
            href={featuredCategories[5].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden min-h-[280px] cursor-pointer"
          >
            <img
              src={cardImages[5]}
              alt="Cappelli"
              title="Headwear - Itaobuy Spreadsheet"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6">
              <h3 className="text-2xl md:text-3xl font-bold text-background-50">
                Headwear
              </h3>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}